import { render, staticRenderFns } from "./SHImage.vue?vue&type=template&id=51893184&scoped=true&"
import script from "./SHImage.vue?vue&type=script&lang=js&"
export * from "./SHImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51893184",
  null
  
)

export default component.exports